import script from "./add-user-dialog.vue?vue&type=script&setup=true&lang=js"
export * from "./add-user-dialog.vue?vue&type=script&setup=true&lang=js"

import "./add-user-dialog.vue?vue&type=style&index=0&id=40269db8&lang=scss"

const __exports__ = script;

export default __exports__